export default __webpack_public_path__ + "static/media/popular.8cae855a.svg";